import { FC } from 'react';

import { AuthProvider } from './auth';
import { BillingDataProvider } from './billingData';
import { ClipBoardManualProvider } from './clipBoardManual';
import { DataSheetsProvider } from './dataSheets';
import { AppLocaleProvider } from './locale';
import { MuscleGroupProvider } from './muscleGroup';
import { PackagesProvider } from './packages';
import { PowerCreatorProvider } from './powerCreator';
import { PrescriptionProvider } from './prescription';
import { ScreenProvider } from './screen';
import { SequencyProvider } from './sequency';
import { SidebarProvider } from './sidebar';
import { StudentProvider } from './student';
import { AppThemeProvider } from './theme';
import { TrainingStoreProvider } from './trainingStore';
import LoadingProvider from './loading';

const AppProvider: FC = ({ children }) => {
  return (
    <ClipBoardManualProvider>
      <AuthProvider>
        <LoadingProvider>
          <AppLocaleProvider>
            <AppThemeProvider>
              <BillingDataProvider>
                <SidebarProvider>
                  <StudentProvider>
                    <DataSheetsProvider>
                      <PackagesProvider>
                        <ScreenProvider>
                          <SequencyProvider>
                            <MuscleGroupProvider>
                              <PrescriptionProvider>
                                <TrainingStoreProvider>
                                  <PowerCreatorProvider>
                                    {children}
                                  </PowerCreatorProvider>
                                </TrainingStoreProvider>
                              </PrescriptionProvider>
                            </MuscleGroupProvider>
                          </SequencyProvider>
                        </ScreenProvider>
                      </PackagesProvider>
                    </DataSheetsProvider>
                  </StudentProvider>
                </SidebarProvider>
              </BillingDataProvider>
            </AppThemeProvider>
          </AppLocaleProvider>
        </LoadingProvider>
      </AuthProvider>
    </ClipBoardManualProvider>
  );
};

export default AppProvider;
